module.exports = __webpack_public_path__ + "static/media/prudential.f5d86df2.svg";